// TODO: Refactor this to rely on registration query. Move logic into registration_actions_component
import { SchedulerModel } from '../../views/course_scheduler/models/scheduler_model';
import { TermProgramInfoModel } from '../../views/term_courses/models/term_program_info_model';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';

import * as _4 from 'lodash4';

export class RegistrationRTRSvc {
  private configs = {
    isRTR: false,
    termNk: '',
    SIS_URL: '',
    crns: [],
    registrationUrl: ''
  };
  private registrationCrns: string[];

  constructor(
    private ngSchedulerModel: SchedulerModel,
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private schedulerConfigModel: any,
    private FEATURE_SCHEDULE_REGISTRATION_URL_CRN: any,
    private ngSectionsDatasource: ISectionsDatasource
  ) {}

  setSISURL(sisUrl: string) {
    this.configs.SIS_URL = sisUrl;
  }
  buildUrl() {
    const getCrns = (crns: any) => {
      return _4.map(crns, (crn, index) => {
        const formattedIndex = _4.padStart((index + 1).toString(), 2, '0');
        return `&crn${formattedIndex}=${crn}`;
      });
    };
    const crnList = getCrns(this.registrationCrns);

    return `${this.configs.SIS_URL}?term_in=${this.configs.termNk}${crnList.join('')}`;
  }
  init(sectionsToRegister: any) {
    this.configs.isRTR = this.schedulerConfigModel.isFeatureEnabled(this.FEATURE_SCHEDULE_REGISTRATION_URL_CRN);
    const schedulerModel = this.ngSchedulerModel.read();
    this.configs.SIS_URL = !_4.isEmpty(_4.get(schedulerModel, 'customtext.SIS_REGISTRATION_URL.text'))
      ? schedulerModel.customtext.SIS_REGISTRATION_URL.text
      : '';

    if (this.configs.isRTR) {
      const termInfo = this.ngTermProgramInfoModel.read().term;
      if (termInfo) {
        this.configs.termNk = termInfo.nk;
      }
      this.configs.registrationUrl = this.buildUrl();
    } else {
      this.configs.registrationUrl = this.configs.SIS_URL;
    }

    this.updateCRNs(sectionsToRegister);

    return this.configs.registrationUrl;
  }
  hasCrns() {
    return !_4.isEmpty(this.registrationCrns);
  }

  updateCRNs(sectionsToRegister: any) {
    const sectionsCd = _4.map(sectionsToRegister, (regSection: any) => {
      const section = this.ngSectionsDatasource.get(regSection.id);
      return section ? section.cd : '';
    });
    this.registrationCrns = _4.filter(sectionsCd, (sectionCd: any) => !_4.isEmpty(sectionCd));
  }
}

angular.module('capability-ng-scheduler').service('registrationRTRSvc', RegistrationRTRSvc);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/registration_rtr/registration_rtr.ts